export const QuickStartErrorMessages = {
    frn: {
        notFound: 'FRN not found. Please check your entry and try again.',
    },
} as const;

export const QuickStartFrnNotFoundModalMessages = {
    title: 'FRN Not Found',
    content:
        'This FRN was not found. Select Next to start the application without an FRN or Cancel to try again.',
    primaryActionTitle: 'Next',
} as const;
